import { ArrayUtils, StringUtils, NumberUtils } from "neo-common";
import { Configuration } from "../Components/Configuration";
import { Scaling } from "../Utils/Scaling";
import { StageController } from "../Components/StageController";
import { ILayoutElement } from "../CustomComponents/ILayoutElement";

export class LayoutManager {
    private static readonly ExtraPortraitClass: string = "extendPortrait";

    private static SwitchPrefix = "";

    private static PreviousSwitchPrefix = "";

    private static LayoutElements: Array<ILayoutElement> = [];

    private platform: string;

    private usePlatform: boolean;

    private width: Array<number>;

    private height: Array<number>;

    private ratioIntervals: Array<Array<number>>;

    private configured: boolean;

    constructor() {
        this.usePlatform = false;
        this.configured = false;
        this.ratioIntervals = [];

        let config: Element = Configuration.Configurations["LayoutManagerConfiguration"];
        if (config != null) {
            this.configurate(config);
            this.configured = true;
        }

        if (Scaling.Emitter != null) {
            Scaling.Emitter.on(Scaling.EventResize, this.onLayoutChange.bind(this));
        }
    }

    public static addLayoutElement(layoutElement: ILayoutElement): void {
        LayoutManager.LayoutElements.push(layoutElement);
    }

    public static getSwitchPrefix(): string {
        return LayoutManager.SwitchPrefix;
    }

    public static getPreviousSwitchPrefix(): string {
        return LayoutManager.PreviousSwitchPrefix;
    }

    private configurate(node: Element): void {
        this.platform =
            window["CHANNEL"] == "mobile" ? LayoutManagerAttributes.MOBILE : LayoutManagerAttributes.DESKTOP;

        if (node.hasAttribute(LayoutManagerConfigurationAttributes.USE_PLATFORM)) {
            this.usePlatform = StringUtils.parseBoolean(
                node.getAttribute(LayoutManagerConfigurationAttributes.USE_PLATFORM),
            );
        }

        if (node.hasAttribute(LayoutManagerConfigurationAttributes.WIDTH)) {
            this.width = ArrayUtils.numberArray(node.getAttribute(LayoutManagerConfigurationAttributes.WIDTH));
        }

        if (node.hasAttribute(LayoutManagerConfigurationAttributes.HEIGHT)) {
            this.height = ArrayUtils.numberArray(node.getAttribute(LayoutManagerConfigurationAttributes.HEIGHT));
        }

        if (node.hasAttribute(LayoutManagerConfigurationAttributes.RATIO_INTERVALS)) {
            let intervals = ArrayUtils.stringArray(
                node.getAttribute(LayoutManagerConfigurationAttributes.RATIO_INTERVALS),
                "|",
            );

            for (let i = 0; i < intervals.length; i++) {
                this.ratioIntervals.push(ArrayUtils.numberArray(intervals[i]));
            }
        }
    }

    private onLayoutChange(
        isPortrait: boolean,
        ratio: number,
        screenWidth: number,
        screenHeight: number,
        ratioWidth: number,
        ratioHeight: number,
    ): void {
        if (!this.configured) {
            return;
        }

        isPortrait = this.allowedPortraitLayout(isPortrait, ratio);

        LayoutManager.SwitchPrefix = "";
        if (this.usePlatform) {
            LayoutManager.SwitchPrefix = this.platform + "_";
        }

        if (isPortrait) {
            document.body.classList.add(LayoutManager.ExtraPortraitClass);
        } else {
            document.body.classList.remove(LayoutManager.ExtraPortraitClass);
        }

        this.changeCanvasSize(isPortrait, screenWidth, screenHeight, ratioWidth, ratioHeight);
        this.updateLayoutElements(isPortrait);

        LayoutManager.PreviousSwitchPrefix = LayoutManager.SwitchPrefix;
    }

    private allowedPortraitLayout(isPortrait: boolean, ratio: number): boolean {
        if (isPortrait) {
            for (let i = 0; i < this.ratioIntervals.length; i++) {
                if (ratio > this.ratioIntervals[i][0] && ratio < this.ratioIntervals[i][1]) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }

    private changeCanvasSize(
        isPortrait: boolean,
        screenWidth: number,
        screenHeight: number,
        ratioWidth: number,
        ratioHeight: number,
    ): void {
        let screen = document.getElementById("screen");
        if (isPortrait) {
            let offset = parseInt(window.getComputedStyle(screen).top);
            let height = (screenHeight * (1 / ratioWidth) - offset) * (1920 / 1080);
            StageController.Renderer.resize(this.width[1], height); //portrait
        } else {
            StageController.Renderer.resize(this.width[0], this.height[0]); //landscape
        }

        //ToDo render only if renderer is paused
        StageController.Renderer.render(StageController.Stage);
    }

    private updateLayoutElements(isPortrait: boolean): void {
        for (let i = 0; i < LayoutManager.LayoutElements.length; i++) {
            LayoutManager.LayoutElements[i].onLayoutChange(isPortrait);
        }
    }
}

export const LayoutManagerConfigurationAttributes = {
    USE_ORIENTATION: "UseOrientation",
    USE_PLATFORM: "UsePlatform",
    HEIGHT: "Height",
    WIDTH: "Width",
    RATIO_INTERVALS: "RatioIntervals",
};

export const LayoutManagerAttributes = {
    PORTRAIT: "PORTRAIT",
    LANDSCAPE: "LANDSCAPE",
    DESKTOP: "DESKTOP",
    MOBILE: "MOBILE",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/LayoutManager.ts
 **/